import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import type { TrackedToolComponent } from '@analytics/models';
import { Store } from '@ngrx/store';

import type { SolarPanelOrderFormToolTrackingSteps } from '../../store';
import {
  parsedSolarPanelsOrderFormToolTrackingConfig,
  selectSolarPanelsOrderFormViewModel,
} from '../../store';
import { SolarPanelsOrderFormRendering } from '../../models/solar-panels-order-form-rendering.interface';
import { initializeSolarPanelsFunnelComponent } from '../../utils/initialize-solar-panels-funnel-component';

@Component({
  selector: 'wl-solar-panels-order-form-container[rendering]',
  templateUrl: './solar-panels-order-form-container.component.html',
})
export class SolarPanelsOrderFormContainerComponent
  implements OnInit, TrackedToolComponent<SolarPanelOrderFormToolTrackingSteps>
{
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: SolarPanelsOrderFormRendering;
  public solarPanelsOrderFormViewModel$ = this.store$.select(
    selectSolarPanelsOrderFormViewModel
  );

  constructor(protected readonly store$: Store) {}

  ngOnInit() {
    this.store$.dispatch(
      initializeSolarPanelsFunnelComponent(
        'orderForm',
        this.rendering?.fields.FunnelSettings
      )
    );
  }

  get trackToolConfig() {
    const toolName = this.rendering.fields.componentName.value;
    return parsedSolarPanelsOrderFormToolTrackingConfig(toolName);
  }
}
